import { GET_SHE, SET_LOADING_SHE, SET_PAGINATION_SHE } from '../constant';

const initialState = {
  data: [],
  loadingData: false,
  dataPagination: 0,
  totalData: 0,
};

const sheReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_SHE: {
      return {
        ...state,
        loadingData: action?.payload,
      };
    }
    case SET_PAGINATION_SHE: {
      return {
        ...state,
        dataPagination: action?.payload,
      };
    }
    case GET_SHE: {
      return {
        ...state,
        data: action?.payload?.data || [],
        totalData: action?.payload?.total,
        loadingData: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default sheReducer;
